import { render } from "./WarningPopup.vue?vue&type=template&id=66001870"
import script from "./WarningPopup.vue?vue&type=script&lang=js"
export * from "./WarningPopup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__